var React = require('react');

function UstaShirtIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#3E424E","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","opacity":".5"},[React.createElement("path",{"d":"M47.522 6C45.226 9.961 40.928 12.63 36 12.63c-4.927 0-9.224-2.669-11.52-6.63L3 14.182l2.286 14.046h10.187v36.894c0 .485.396.878.885.878h39.285c.489 0 .884-.394.884-.878V28.228h10.188L69 14.182 47.522 6z","key":0}),React.createElement("path",{"d":"M36 12.63c4.927 0 9.225-2.669 11.521-6.63H24.48c2.296 3.961 6.594 6.63 11.52 6.63z","key":1})]));
}

UstaShirtIcon.defaultProps = {"width":"72","height":"72","fill":"none","viewBox":"0 0 72 72"};

module.exports = UstaShirtIcon;

UstaShirtIcon.default = UstaShirtIcon;
